import { Link, Typography } from "@carrotfertility/carotene-core"
import { CircleImage } from "../../../views/atoms/images/CircleImage"
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { RequirementCard } from "./requirement-card"

export const DoulaRequirementsCard = (): JSX.Element => {
  const intl = useIntl()
  return (
    <RequirementCard
      icon={<CircleImage iconName="icn-documents" backgroundColor={"black-10"} />}
      title={<FormattedMessage defaultMessage="Doula requirements" />}
      body={
        <Typography key="doula-requirements" variant="body2">
          <FormattedMessage
            defaultMessage="Your doula must be part of our network to be eligible. <link>Learn more in your benefit guide</link>."
            values={{
              link: (linkContent) => (
                <Link
                  fontSize="inherit"
                  target="_blank"
                  href="/your-benefit-guide/coverage/pregnancy-and-postpartum"
                  color="inherit"
                  aria-label={intl.formatMessage({ defaultMessage: "Learn more in your benefit guide" })}
                >
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>
      }
    />
  )
}
